
import BackendResourceDataTable from '@/components/BackendResourceDataTable.vue';
import ScanQRCodeComponent from '@/components/ScanQRCodeComponent.vue';
import { mainStore, ordemCarregamentoStore, userToolStore } from '@/store';
import _ from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  components: { BackendResourceDataTable, ScanQRCodeComponent },
})
export default class ListConferencia extends Vue {
  isLoading = false;
  loadingConferencia = false;
  showConferidas = false;

  scannedNFs = {};

  statusOptions = {
    3: {
      color: 'success',
      label: 'Conferido',
    },
    2: {
      color: 'blue',
      label: 'Aguardando NF',
    },
    1: {
      color: 'warning',
      label: 'Em conferência',
    },
    0: {
      color: 'error',
      label: 'Aguardando conferência',
    },
  };

  get conferenciaTool() {
    return (
      _.find(userToolStore.currentUserTools, { tool_id: 87 }) || {
        allow_view: false,
        allow_edit: false,
        allow_delete: false,
        allow_create: false,
      }
    );
  }

  get currentUser() {
    return mainStore.userProfile!;
  }

  getScannedNF(t016_numero_documento: string) {
    return _.get(this.scannedNFs, t016_numero_documento);
  }

  async onDecode({ t016_numero_documento, t025_codigo, volume, volumes, separado_por_id, lido_por_id, conferido_por }) {
    if (!t016_numero_documento) return;

    if (!this.conferenciaTool.allow_create) {
      this.$swal({
        icon: 'error',
        title: 'Usuário não autorizado',
        text: 'Permissão não encontrada',
      });
      return;
    }

    if (conferido_por) {
      return this.throwError(t016_numero_documento, `Volumes já conferidos por ${conferido_por.full_name}`);
    }

    if (!separado_por_id) {
      return this.throwError(t016_numero_documento, `Separação dos volumes não realizada`);
    }

    if (!lido_por_id) {
      return this.throwError(t016_numero_documento, `Leitura dos produtos não realizada`);
    }

    this.loadingConferencia = true;
    let scannedNF = this.getScannedNF(t016_numero_documento);

    if (!scannedNF) {
      scannedNF = {
        t025_codigo,
        t016_numero_documento,
        totalVolumes: _.sum(_.values(volumes)),
        scannedVolumes: [],
      };
      this.scannedNFs[t016_numero_documento] = scannedNF;
    }

    if (volume != 0) {
      this.onScanVolume(scannedNF, volume);
    } else {
      await this.onScanNF(t016_numero_documento);
    }
    this.loadingConferencia = false;
  }

  onScanVolume(scannedNF: any, volume: string) {
    const volumeName = `${scannedNF.t016_numero_documento}/${volume}`;
    const { scannedVolumes, totalVolumes } = scannedNF;

    if (scannedVolumes.length === totalVolumes) {
      return this.throwError(
        scannedNF.t016_numero_documento,
        `Todos os volumes já foram lidos para a Ordem de Carregamento ${scannedNF.t025_codigo}`
      );
    }

    if (_.includes(scannedVolumes, volumeName)) {
      return this.throwError(
        scannedNF.t016_numero_documento,
        `Este volume já foi lido para a Ordem de Carregamento ${scannedNF.t025_codigo}`
      );
    }
    this.pushVolume(scannedNF, volumeName);

    ordemCarregamentoStore.setItems(
      _.map(ordemCarregamentoStore.items, (i) => {
        if (i.t016_numero_documento === scannedNF.t016_numero_documento) {
          const scannedVolumesQtd = scannedNF.scannedVolumes.length;
          const totalVolumesQtd = scannedNF.totalVolumes;

          switch (true) {
            case scannedNF.finished:
              i.status_conferencia = 3;
              break;
            case scannedVolumesQtd === totalVolumesQtd:
              i.status_conferencia = 2;
              break;
            case scannedVolumes > 0:
              i.status_conferencia = 1;
              break;
          }
        }
        return i;
      })
    );
  }

  async onScanNF(t016_numero_documento) {
    const scannedNF = this.getScannedNF(t016_numero_documento);
    if (!scannedNF) {
      return this.throwError(t016_numero_documento, `Nenhum volume escaneado para a NF ${t016_numero_documento}`);
    }
    const scannedVolumesQtd = scannedNF.scannedVolumes.length;
    const totalVolumesQtd = scannedNF.totalVolumes;

    if (scannedVolumesQtd < totalVolumesQtd) {
      return this.throwError(
        t016_numero_documento,
        `${totalVolumesQtd - scannedVolumesQtd} volumes faltando para leitura.`
      );
    }

    const conferido = await ordemCarregamentoStore.updateOrdemCarregamentoConferidoPorId({
      t016NumeroDocumento: t016_numero_documento,
      conferido_por_id: this.currentUser.id,
    });

    if (conferido) {
      this.scannedNFs[t016_numero_documento].finished = true;
      return this.$swal({
        icon: 'success',
        title: `NF ${t016_numero_documento}`,
        text: 'Nota Fiscal conferida com sucesso!',
      });
    }
  }

  getSumVolumes(volumes: any) {
    return _.sum(_.values(volumes));
  }

  throwError(t016_numero_documento: string, message: string) {
    this.$swal({
      icon: 'error',
      title: `NF ${t016_numero_documento}`,
      text: message,
    });
  }

  pushVolume(scannedNF: any, volumeName: string) {
    this.scannedNFs[scannedNF.t016_numero_documento].scannedVolumes.push(volumeName);

    this.$swal({
      icon: 'success',
      title: `NF ${scannedNF.t016_numero_documento}`,
      text: `Volume ${this.scannedNFs[scannedNF.t016_numero_documento].scannedVolumes.length} de ${
        this.scannedNFs[scannedNF.t016_numero_documento].totalVolumes
      } escaneado para a Ordem de Carregamento ${scannedNF.t025_codigo}`,
    });
    return this.scannedNFs;
  }

  async mounted() {
    ordemCarregamentoStore.setOrdemCarregamento(null);
  }
}
